module.exports = __webpack_public_path__ + "assets/images/20-1ywA-UY.jpg";